module.exports = __webpack_public_path__ + "static/media/md-wine.1d82d46b.svg";